<div class="mb-checkout-review"
     data-cy="mb-checkout-review">
  <form [formGroup]="reviewForm" (ngSubmit)="next()">
    <div class="row no-gutters mb-checkout-review-headline">
      <div class="col-12 text-left mb-checkout-headline"
           data-cy="mb-checkout-review-info-label">
        {{ 'review.headline' | cxTranslate }}
      </div>

    </div>

    <!---------------------->
    <!-- INFO REVIEW AREA -->
    <!---------------------->
    <ng-container *ngIf="!isPurchaseCheckoutType">
      <div class="row no-gutters">
        <div class="col-12 col-sm-6 pr-sm-3">
          <div class="row no-gutters">
            <div class="col-12 mb-4 mb-checkout-review-component-border"  data-cy="mb-review-contact-details">
              <mb-checkout-information-tile [title]="'review.contactDetails'"
                                            [data]="contactDetails"
                                            [type]="infoTypes.CONTACT_DETAILS"
                                            [isEditable]="true"
                                            [linkToEditComponent]="'/' + checkoutRoutes?.routing?.routes?.checkoutContactDetails?.paths[0]">
              </mb-checkout-information-tile>
            </div>
            <div class="col-12 mb-4 mb-checkout-review-component-border" data-cy="mb-review-shipping-address">
              <mb-checkout-information-tile [title]="'review.shippingAddress'"
                                            [data]="shipmentAddress"
                                            [type]="infoTypes.ADDRESS"
                                            [isEditable]="true"
                                            [linkToEditComponent]="'/' + checkoutRoutes?.routing?.routes?.checkoutShippingAddress?.paths[0]"
                                            [formRegion]="checkoutRegion">
              </mb-checkout-information-tile>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 pl-sm-3">
          <div class="row no-gutters">
            <div class="col-12 mb-4 mb-checkout-review-component-border" data-cy="mb-review-billing-address">
              <mb-checkout-information-tile [title]="'review.billingInformation'"
                                            [data]="billingInformation?.billingAddress"
                                            [type]="infoTypes.ADDRESS"
                                            [isEditable]="true"
                                            [linkToEditComponent]="'/' + checkoutRoutes?.routing?.routes?.checkoutBillingInfo?.paths[0]"
                                            [formRegion]="checkoutRegion">
              </mb-checkout-information-tile>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!--------------------------->
    <!-- ADDITIONAL NOTES AREA -->
    <!--------------------------->
    <div class="row no-gutters mb-input-margin-bottom">
      <div class="col-12 field-wrapper"
           mbFloatingLabel
           data-cy="mb-checkout-review-additional-notes">
        <label for="checkoutNotes" class="mb-custom-label mb-input-field-cursor">
          <span class="d-block d-sm-none">{{ 'review.checkoutNotesMobile' | cxTranslate }}</span>
          <span class="d-none d-sm-block">{{ 'review.checkoutNotes' | cxTranslate }}</span>
        </label>
        <textarea class="w-100 mx-auto mb-form-textarea"
                  type="text"
                  id="checkoutNotes"
                  name="checkoutNotes"
                  formControlName="checkoutNotes"
                  data-cy="mb-checkout-review-additional-notes-input"
                  autocomplete="off"
                  mbTextareaAutoresize>
        </textarea>
        <mb-form-errors [control]="reviewForm.get(constants.CHECKOUT_NOTES_CODE)"
                        [prefix]="'formValidationErrors'">
        </mb-form-errors>
      </div>
    </div>

    <!--------------------->
    <!-- CART ITEMS AREA -->
    <!--------------------->
    <div class="row no-gutters mb-2 mb-checkout-review-cart-header">{{ 'mbcommon.yourCart' | cxTranslate }}</div>
    <div class="row no-gutters">
      <div *ngIf="component?.data$ | async as data"
           class="col-12 p-0 mb-4 mb-checkout-review-cart-subheader">
        <span [innerHTML]="data.infoCartText"></span>
      </div>
      <div class="col-12 p-0">
        <mb-cart-details [isDisplayedInCartPage]="false"></mb-cart-details>
      </div>
    </div>


  </form>
</div>

